import { Component, OnInit } from '@angular/core';
import { SmmService } from '../../../_services/smm.service';
import * as html2pdf from 'html2pdf.js';
const moment = require('moment');
@Component({
    selector: 'app-dashboard2',
    templateUrl: './dashboard2.component.html',
    styleUrls: ['./dashboard2.component.scss']
})
// @HostListener('scroll', ['$event'])
export class Dashboard2Component implements OnInit {
    provinceFilter = true;
    sourceByTopicFilter = true;

    negativeFaceBook = [];
    news_article_negative = [];
    
    news_facebook = [];
    news_article = [];

    chartWidth = 400;
    currentFilter = null;

    // for chart
    bgColor = "transparent";
    typeCounts: Array<number> = [];
    typeNames: Array<any> = [];
    displayDateInput = 0;
    pieChartTitle = "NGUỒN THẢO LUẬN";
    pieChartDetailTitle = "bài viết";
    dateInput = { start: moment().subtract(1, 'day'), end: moment() };
    public chartName = "nguon_thao_luan";// Tên chart
    public verticalAlign = "top";
    public maxHeight = 0;
    public marginTop = 50;// Vị trí của chart so với top


    constructor(private postService: SmmService) { }
    ngOnInit() {

    }

    resetData() {
        this.negativeFaceBook = [];
        this.news_article_negative = [];

        this.news_facebook = [];
        this.news_article = [];

        this.typeCounts = [];
        this.typeNames = [];
    }

    onFilterChange(filter) {
        this.currentFilter = filter;
        this.resetData();
        this.getDiscussContent(filter);
        this.getDataFromServer(filter, ['user_post', 'group_post', 'page_post','youtube','tiktok'], 'negativeFaceBook');
        this.getDataFromServer(filter, ['user_post', 'group_post', 'page_post','youtube','tiktok'], 'news_facebook');
        //this.getDataFromServer(filter, ['tiktok'], 'news_facebook');
        this.getDataFromServer(filter, ['news_article', 'news_forum', 'news_blog'], 'news_article_negative');
        this.getDataFromServer(filter, ['news_article', 'news_forum', 'news_blog'], 'news_article');
    }

    getHostname(url) {
        return new URL(url).hostname;
    }
    getPostFacebookUrl(docId) {
        return `https://facebook.com/${docId}`
    }

    getDiscussContent(filter) {
        // filter['sentiment'] = ['NEG'];
        filter['index'] = 'full';
        this.postService.getPostsDiscussionSource({ filter: filter }).subscribe(res => {
            if (res.success) {
                res.data.aggregations
                for (var _key in res.data.aggregations) {
                    if(_key == "Article") {
                        this.typeNames.push("Báo chí");
                    } else if(_key == "Forum") {
                        this.typeNames.push("Diễn đàn");
                    }else {
                        this.typeNames.push(_key);
                    }
                    this.typeCounts.push(res.data.aggregations[_key].doc_count);
                }
            }
        })
    }
    
    getDataFromServer(filter, docType, mode, from = 0) {
        let body = {
            filter: Object.assign({},filter),
            docType: docType, //news_article
            isNegativePost: (mode == 'negativeFaceBook' || mode == 'news_article_negative') ? true : false,
            size: 20,
            from: from,
            mode: mode
        }
        if(mode == 'news_article' || mode == 'news_article_negative') {
            delete body.filter['provinces'];
        }

        this.postService.getRecentPost(body).subscribe(res => {
            if (res.success && res.data.hits.hits.length > 0) {
                switch (mode) {
                    case 'negativeFaceBook':
                        this.negativeFaceBook = this.negativeFaceBook.length == 0 ? res.data.hits.hits : this.negativeFaceBook.concat(res.data.hits.hits);
                        break;
                    case 'news_article_negative':
                        this.news_article_negative = this.news_article_negative.length == 0 ? res.data.hits.hits : this.news_article_negative.concat(res.data.hits.hits);
                        break;
                    case 'news_article':
                        this.news_article = this.news_article.length == 0 ? res.data.hits.hits : this.news_article.concat(res.data.hits.hits);
                        break;
                    case 'news_facebook':
                        this.news_facebook = this.news_facebook.length == 0 ? res.data.hits.hits : this.news_facebook.concat(res.data.hits.hits);
                        break;
                    default:
                        break;
                }
            }
        });
    }

    clickLoadMore(mode) {
            switch (mode) {
                case 'negativeFaceBook':
                    const from = this.negativeFaceBook.length;
                    this.getDataFromServer(this.currentFilter, ['user_post', 'group_post', 'page_post','youtube','tiktok'], 'negativeFaceBook', from);
                    break;
                case 'news_article_negative':
                    const from1 = this.news_article_negative.length;
                    this.getDataFromServer(this.currentFilter, ['news_article','news_forum', 'news_blog'], 'news_article_negative', from1);
                    break;
                case 'news_article':
                    const from2 = this.news_article.length;
                    this.getDataFromServer(this.currentFilter, ['news_article','news_forum', 'news_blog'], 'news_article', from2);
                    break;
                case 'news_facebook':
                    const from3 = this.news_facebook.length;
                    this.getDataFromServer(this.currentFilter, ['user_post', 'group_post', 'page_post','youtube', 'tiktok'], 'news_facebook', from3);
                    break;
                default:
                    break;
            }
        
    }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard2/dashboard2.component.ts